import React, { useState } from "react";
import axios from "axios";

const API = "/backend/public/api";

function Contact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const sendMessage = async () => {
    try {
      await axios.post(`${API}/contact`, {
        name,
        email,
        message,
      });

      alert("Message Sent Successfully ✅");

      setName("");
      setEmail("");
      setMessage("");
    } catch (err) {
      alert("Error sending message ❌");
    }
  };

  return (
    <div id="contact" className="container py-5">
      <h2 className="text-center mb-4">Contact Us</h2>

      <div className="row">

        <div className="col-md-6">
          <input className="form-control mb-3" placeholder="Your Name" onChange={(e) => setName(e.target.value)} />
          <input className="form-control mb-3" placeholder="Your Email" onChange={(e) => setEmail(e.target.value)} />
          <textarea className="form-control mb-3" placeholder="Your Message" rows="4" onChange={(e) => setMessage(e.target.value)} />

          <button className="btn btn-primary w-100" onClick={sendMessage}>
            Send Message
          </button>
        </div>

        <div className="col-md-6">
          <iframe
            title="map"
            src="https://www.google.com/maps?q=bankura&output=embed"
            width="100%"
            height="300"
            style={{ border: 0 }}
          ></iframe>
        </div>

      </div>
    </div>
  );
}

export default Contact;


